// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  font-size: 20px;
  border-bottom: none !important;
}

.secondary-nav {
  background-color: var(--nav-background);
  color: var(--nav-text-color);
}

h1.header {
  margin: auto 0;
  font-weight: normal;
}

.header-image {
  height: 3rem;
  padding-right: 1rem;
}

.header-image:focus {
  outline-color: white !important;
}

#user-trigger {
  pointer-events: none;
}

@media (prefers-color-scheme: light) {
  .primary-nav {
    background-color: #346581;
    color: white;
  }
}
@media (prefers-color-scheme: dark) {
  .primary-nav {
    background-color: var(--color-primary);
    color: white;
  }
}
.nav-buttons {
  display: flex;
  align-items: center;
}

.nav-button {
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 8px 12px;
  font-size: 14px;
}

.icon-person {
  display: inline-block;
  width: 24px;
  height: 24px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 256c52.805 0 96-43.201 96-96s-43.195-96-96-96-96 43.201-96 96 43.195 96 96 96zm0 48c-63.598 0-192 32.402-192 96v48h384v-48c0-63.598-128.402-96-192-96z" fill="white"/></svg>');
  background-size: contain;
}

.admin-item {
  display: flex;
  align-items: center;
  background-color: transparent;
  font-size: 14px;
  border: 0;
}

.admin-select-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.adminLabel {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 4px;
}

.admin-dropdown-selected,
.admin-dropdown-item {
  font-size: 14px;
  text-transform: uppercase;
}

.container {
  display: flex;
  justify-content: center;
  padding: 3px 6px;
  margin: auto;
}

.header-title {
  margin-inline: auto;
  max-width: 1440px;
  padding-top: 1rem;
}

.toolbar-container {
  display: flex;
  justify-items: center;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 5px;
  max-width: 1440px;
  margin-inline: auto;
  width: 100%;
  padding-inline: 18px;
}

.custom-toolbar {
  position: sticky;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px 6px;
  margin: auto;
}

.button-container {
  display: inline-block;
  margin-right: 8px;
}

:host ::ng-deep .p-button {
  background: transparent;
  border: 0;
  gap: 12px;
}

.admin-page-display {
  display: none;
}

img:hover {
  cursor: pointer;
}

:host ::ng-deep .p-button-label {
  font-weight: normal !important;
}

:host ::ng-deep .p-dropdown-label {
  display: flex;
  gap: 10px;
  width: -moz-fit-content;
  width: fit-content;
}`, "",{"version":3,"sources":["webpack://./src/app/core/header/header.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,8BAAA;AACF;;AAEA;EACE,uCAAA;EACA,4BAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAGA;EACE;IACE,yBAAA;IACA,YAAA;EAAF;AACF;AAEA;EACE;IACE,sCAAA;IACA,YAAA;EAAF;AACF;AAGA;EACE,aAAA;EACA,mBAAA;AADF;;AAIA;EACE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AADF;;AAIA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,ySAAA;EACA,wBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,SAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AADF;;AAIA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AADF;;AAKA;;EAEE,eAAA;EACA,yBAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;AAFF;;AAKA;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAFF;;AAKA;EACE,qBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,uBAAA;EACA,SAAA;EACA,SAAA;AAFF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,8BAAA;AADF;;AAKA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EAAA,kBAAA;AAFF","sourcesContent":[".header {\r\n  font-size: 20px;\r\n  border-bottom: none !important;\r\n}\r\n\r\n.secondary-nav {\r\n  background-color: var(--nav-background);\r\n  color: var(--nav-text-color);\r\n}\r\n\r\nh1.header {\r\n  margin: auto 0;\r\n  font-weight: normal;\r\n}\r\n\r\n.header-image {\r\n  height: 3rem;\r\n  padding-right: 1rem;\r\n}\r\n\r\n.header-image:focus {\r\n  outline-color: white !important;\r\n}\r\n\r\n#user-trigger {\r\n  pointer-events: none;\r\n}\r\n\r\n\r\n@media (prefers-color-scheme: light) {\r\n  .primary-nav {\r\n    background-color: #346581 ;\r\n    color: white;\r\n  }\r\n}\r\n@media (prefers-color-scheme: dark) {\r\n  .primary-nav {\r\n    background-color: var(--color-primary);\r\n    color: white;\r\n  }\r\n}\r\n\r\n.nav-buttons {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.nav-button {\r\n  background: transparent;\r\n  border: none;\r\n  color: inherit;\r\n  cursor: pointer;\r\n  padding: 8px 12px;\r\n  font-size: 14px;\r\n}\r\n\r\n.icon-person {\r\n  display: inline-block;\r\n  width: 24px;\r\n  height: 24px;\r\n  background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path d=\"M256 256c52.805 0 96-43.201 96-96s-43.195-96-96-96-96 43.201-96 96 43.195 96 96 96zm0 48c-63.598 0-192 32.402-192 96v48h384v-48c0-63.598-128.402-96-192-96z\" fill=\"white\"/></svg>');\r\n  background-size: contain;\r\n}\r\n\r\n.admin-item {\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: transparent;\r\n  font-size: 14px;\r\n  border: 0;\r\n}\r\n\r\n.admin-select-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n}\r\n\r\n.adminLabel {\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n\r\n.admin-dropdown-selected,\r\n.admin-dropdown-item {\r\n  font-size: 14px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.container {\r\n  display: flex;\r\n  justify-content: center;\r\n  padding: 3px 6px;\r\n  margin: auto;\r\n}\r\n\r\n.header-title {\r\n  margin-inline: auto;\r\n  max-width: 1440px;\r\n  padding-top: 1rem;\r\n}\r\n\r\n.toolbar-container {\r\n  display: flex;\r\n  justify-items: center;\r\n  align-items: center;\r\n  padding-top: 10px;\r\n  padding-bottom: 5px;\r\n  max-width: 1440px;\r\n  margin-inline: auto;\r\n  width: 100%;\r\n  padding-inline: 18px;\r\n}\r\n\r\n.custom-toolbar {\r\n  position: sticky;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 3px 6px;\r\n  margin: auto;\r\n}\r\n\r\n.button-container {\r\n  display: inline-block;\r\n  margin-right: 8px;\r\n}\r\n\r\n:host ::ng-deep .p-button{\r\n  background: transparent;\r\n  border: 0;\r\n  gap:12px;\r\n}\r\n.admin-page-display {\r\n  display: none;\r\n}\r\n\r\nimg:hover {\r\n  cursor: pointer;\r\n}\r\n\r\n:host ::ng-deep .p-button-label{\r\n  font-weight: normal !important;\r\n}\r\n\r\n\r\n:host ::ng-deep .p-dropdown-label{\r\n  display: flex;\r\n  gap: 10px;\r\n  width: fit-content;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
